import { DesktopIcon, MoonIcon, SunIcon } from '@radix-ui/react-icons';
import { ParseKeys } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../app/hooks/useTheme';
import { ThemeMode } from '../../app/store/slices/themeSlice';
import cn from '../../app/utils/cn';

const options: {
  mode: ThemeMode;
  icon: React.ReactNode;
  labelKey: ParseKeys;
}[] = [
  {
    mode: 'light',
    icon: <SunIcon className="size-3.5" />,
    labelKey: 'sidenavbar.theme.light',
  },
  {
    mode: 'dark',
    icon: <MoonIcon className="size-3.5" />,
    labelKey: 'sidenavbar.theme.dark',
  },
  {
    mode: 'system',
    icon: <DesktopIcon className="size-3.5" />,
    labelKey: 'sidenavbar.theme.system',
  },
];

export default function ThemeToggle() {
  const { mode, setTheme } = useTheme();
  const { t } = useTranslation();

  return (
    <div className="bg-grey-0/50 dark:bg-grey-800 dark:border-grey-600 flex items-center gap-0.5 rounded-full border border-transparent p-0.5 shadow-sm dark:shadow-md dark:shadow-black/40">
      {options.map((option) => {
        const isActive = mode === option.mode;
        return (
          <button
            key={option.mode}
            type="button"
            aria-label={t(option.labelKey)}
            aria-pressed={isActive}
            className={cn(
              'flex size-10 items-center justify-center rounded-full transition-all duration-200 outline-none sm:size-8',
              'focus-visible:ring-2 focus-visible:ring-green-500/50',
              isActive
                ? 'bg-grey-0 dark:bg-grey-600 text-text-brand shadow-md'
                : 'text-text-tertiary hover:text-text-secondary',
            )}
            onClick={() => setTheme(option.mode)}
          >
            {option.icon}
          </button>
        );
      })}
    </div>
  );
}
